/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ListFeaturesResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * FeaturesAPIApi - axios parameter creator
 * @export
 */
export const FeaturesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the list of CASTware features.
         * @summary List CASTware features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cluster-management/v1/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeaturesAPIApi - functional programming interface
 * @export
 */
export const FeaturesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeaturesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the list of CASTware features.
         * @summary List CASTware features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresAPIListFeatures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListFeaturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresAPIListFeatures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeaturesAPIApi.featuresAPIListFeatures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeaturesAPIApi - factory interface
 * @export
 */
export const FeaturesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeaturesAPIApiFp(configuration)
    return {
        /**
         * Gets the list of CASTware features.
         * @summary List CASTware features.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresAPIListFeatures(options?: RawAxiosRequestConfig): AxiosPromise<ListFeaturesResponse> {
            return localVarFp.featuresAPIListFeatures(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeaturesAPIApi - object-oriented interface
 * @export
 * @class FeaturesAPIApi
 * @extends {BaseAPI}
 */
export class FeaturesAPIApi extends BaseAPI {
    /**
     * Gets the list of CASTware features.
     * @summary List CASTware features.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturesAPIApi
     */
    public featuresAPIListFeatures(options?: RawAxiosRequestConfig) {
        return FeaturesAPIApiFp(this.configuration).featuresAPIListFeatures(options).then((request) => request(this.axios, this.basePath));
    }
}

